import localeJa from '@angular/common/locales/ja';
import { NgModule, LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { LogoutModule } from './pages/logout/logout.module';
import { AppStoreModule } from '@shared/store/app-store.module';
import { LoadingModule } from '@organisms/loading/loading.module';
import { CallbackModule } from '@pages/callback/callback.module';
import { AuthStoreModule } from '@domains/auth/store/auth-store.module';
import { ErrorHandlerModule } from '@shared/error-handler/error-handler.module';

registerLocaleData(localeJa);

@NgModule({ declarations: [AppComponent],
    bootstrap: [AppComponent], imports: [LogoutModule,
        BrowserModule,
        LoadingModule,
        CallbackModule,
        AppStoreModule,
        AuthStoreModule,
        TranslateModule,
        AppRoutingModule,
        ErrorHandlerModule,
        BrowserAnimationsModule], providers: [
        { provide: 'API_URL', useValue: '/api' },
        { provide: LOCALE_ID, useValue: 'ja-JP' },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule {}
